import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const FloatingCall = () => {
  return (
    <a
      href={BUSINESS.phoneHref}
      data-testid="floating-call-button"
      aria-label={`Call ${BUSINESS.phone}`}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
    >
      <span className="hidden sm:block rounded-full bg-[#0f2452] px-4 py-2 text-sm font-semibold text-white shadow-lg opacity-0 -translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
        Call us now
      </span>
      <span className="relative flex h-16 w-16 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-[#2563eb] icm-ping-ring" />
        <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-[#2563eb] text-white shadow-xl shadow-blue-900/40 transition-transform duration-300 group-hover:scale-105">
          <Phone className="h-7 w-7" />
        </span>
      </span>
    </a>
  );
};
